import React from 'react';
import { LegalFooter } from './LegalFooter';
import { useT } from '../lib/i18n';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function About() {
  const { t } = useT();
  return (
    <div className="grain min-h-screen flex flex-col bg-[#050510] text-white">
      <div className="flex-1 w-full max-w-4xl mx-auto px-6 py-12 relative">
        <Link to="/" className="inline-flex items-center gap-2 text-[#A0A0B0] hover:text-white transition-colors mb-8 font-bold text-sm bg-white/5 px-4 py-2 rounded-xl hover:bg-white/10">
          <ArrowLeft size={18} /> {t("back_home")}
        </Link>
        <h1 className="font-display text-4xl font-black text-[#FFE800] mb-8">{t("about_title")}</h1>
        <div className="space-y-6 text-[#A0A0B0] leading-relaxed text-sm sm:text-base">
           <p>{t("about_intro")}</p>
           <h2 className="text-xl font-bold text-white mt-8 mb-4">{t("about_h1")}</h2>
           <p>{t("about_p1_1")}</p>
           <p>{t("about_p1_2")}</p>
           <h2 className="text-xl font-bold text-white mt-8 mb-4">{t("about_h2")}</h2>
           <p>{t("about_p2")}</p>
        </div>
      </div>
      <LegalFooter screen="O_NAS" />
    </div>
  );
}